"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LatestCataloguesDescription = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LatestCataloguesDescription = (param)=>{
    let { className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _useTranslations.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.LATEST_CATALOGUES_DESCRIPTION),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "h3",
                component: "h1",
                children: translations.landingPageLatestCatalogueTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        variant: "subtitle1",
                        children: translations.landingPageLatestCatalogueSubtitle
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        children: translations.landingPageLatestCatalogueDescription
                    })
                ]
            })
        ]
    });
};
exports.LatestCataloguesDescription = LatestCataloguesDescription;
